export default function CErrors() {
  return <h2>C Errors</h2>;
}
